import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { Button } from '../components/Button';
interface LandingPageProps {
  onLoginClick: () => void;
}
export function LandingPage({
  onLoginClick
}: LandingPageProps) {
  return <div className="min-h-screen w-full bg-gradient-to-br from-stone-50 via-teal-50/30 to-stone-50 flex items-center justify-center" data-id="element-1646">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center" data-id="element-1647">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="flex items-center justify-center gap-3 mb-12" data-id="element-1648">
          <div className="p-4 bg-teal-600 rounded-2xl" data-id="element-1649">
            <ZapIcon className="w-12 h-12 text-white" data-id="element-1650" />
          </div>
          <h1 className="text-5xl font-bold text-stone-900" data-id="element-1651">EL Opgaver</h1>
        </motion.div>

        {/* Login Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} data-id="element-1652">
          <Button onClick={onLoginClick} variant="primary" className="text-lg px-12 py-4" data-id="element-1653">
            Log ind
          </Button>
        </motion.div>
      </motion.div>
    </div>;
}